import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

/**
 * Centre d'aide (Documentation V2) — remplace, à terme, les deux iframes Google Docs
 * (documentation / release-note). Entrée de menu GOD only tant que le contenu n'est pas rempli.
 */
export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.KB,
    loadComponent: () =>
      import('./help-center.component').then((m) => m.HelpCenterComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.KB + '/:slug',
    loadComponent: () =>
      import('./help-center.component').then((m) => m.HelpCenterComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.KB,
    loadComponent: () =>
      import('./help-center.component').then((m) => m.HelpCenterComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.KB + '/:slug',
    loadComponent: () =>
      import('./help-center.component').then((m) => m.HelpCenterComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HelpCenterModule {}
